/**
 * Header JS
 * Handles sticky positioning offsets if announcement bar is present
 */

class SiteHeader extends HTMLElement {
  constructor() {
    super();
    this.header = this;
    this.announcementBar = document.querySelector('.announcement-bar');
    
    this.updateOffset();
    
    // Listen for resize to adjust offset
    window.addEventListener('resize', this.updateOffset.bind(this));
    
    // Set up a mutation observer in case the announcement bar visibility changes
    if (this.announcementBar) {
      this.observer = new MutationObserver(this.updateOffset.bind(this));
      this.observer.observe(this.announcementBar, { attributes: true, attributeFilter: ['style', 'data-visible'] });
    }
  }

  updateOffset() {
    if (!this.announcementBar) {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      return;
    }

    const isVisible = this.announcementBar.getAttribute('data-visible') === 'true' || 
                      window.getComputedStyle(this.announcementBar).display !== 'none';
                      
    if (isVisible) {
      const height = this.announcementBar.offsetHeight;
      document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
    } else {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    }
  }
  
  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    window.removeEventListener('resize', this.updateOffset.bind(this));
  }
}

customElements.define('site-header', SiteHeader);
